import { render, staticRenderFns } from "./PerbaruiProfilPemilikSistem.vue?vue&type=template&id=3f5a962c&scoped=true&"
import script from "./PerbaruiProfilPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./PerbaruiProfilPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5a962c",
  null
  
)

export default component.exports